<template>
  <div class="tickets-wrapper">
    <scroller v-if="ticketList.length">
      <div
        class="ticket-list"
        ref="ticketList"
      >
        <Ticket
          v-for="(ticket, i) in ticketList"
          @toggleSelectedTicket="toggleSelectedTicket($event)"
          :ticket="ticket"
          :checked-ticket="checkedTicket"
          :key="i"
        />
      </div>
    </scroller>
    <button
      v-if="ticketList.length"
      @click="handlePrintButton"
      class="print-copy-button">{{ getTranslation('actions.print_copy') }}</button>
    <div
      v-if="!ticketList.length"
      class="empty-list">
      {{ getTranslation('main.no_results_found') }}
    </div>
  </div>
</template>

<script>
import Ticket from './Ticket.vue';
import gateway from '../../../services/gravityGateway/ticketHistoryGravityGateway';
import formatter from '../../../utility/formatter';

const isGateway = window.location !== window.parent.location;

export default {
  components: {
    Ticket,
  },
  data() {
    return {
      checkedTicket: '',
    };
  },
  computed: {
    ticketList() {
      return this.$store.getters.ticketList;
    },
    translations() {
      return this.$store.getters.getTranslations;
    },
    sevenTaxes() {
      return this.$store.getters.sevenTaxes;
    },
    resetTrigger() {
      return this.$store.state.resetTrigger;
    },
  },
  methods: {
    toggleSelectedTicket(ticketId) {
      this.checkedTicket = this.checkedTicket === ticketId ? '' : ticketId;
    },
    handlePrintButton() {
      if (!this.checkedTicket) {
        gateway.sendMessage('Dialog.Show', {
          message: this.translations.select_ticket || 'select_ticket',
          type: 'info',
          delay: 3000,
        }, true);

        return;
      }

      const translation = this.translations['games.prematchbetting'];

      const selectedTicket = this.ticketList.find(ticket => ticket.id === this.checkedTicket);

      const formattedTicket = formatter.formatTicketForSeven(
        selectedTicket,
        translation,
        this.sevenTaxes,
      );
      formattedTicket.isCopy = true;

      const payload = {
        action: 'Add',
        productId: 'PreMatchBetting',
        responseData: formattedTicket,
      };

      gateway.sendMessage('Tickets.Print', payload);
      gateway.sendMessage('Dialog.Show', {
        message: this.translations.print_copy_success || 'print_copy_success',
        type: 'success',
        delay: 3000,
      }, true);

      this.checkedTicket = '';
    },
    getTranslation(key) {
      return this.$store.getters.getTranslation(key);
    },
    scrollToTop(el) {
      el.scrollTo(0, 0);
    },
  },
  beforeCreate() {
    if (this.$route.query.integrationType === 'gravityGateway' || isGateway) {
      gateway.instance({ dispatch: this.$store.dispatch });
      gateway.init();
    }
  },
  beforeDestroy() {
    this.checkedTicket = {};
  },
  watch: {
    resetTrigger() {
      this.checkedTicket = '';

      if (!this.$refs.ticketList) return;

      this.scrollToTop(this.$refs.ticketList);
    },
  },
};
</script>

<style lang="scss">
.tickets-wrapper {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  width: 100%;
  height: 100vh;
  font-size: 16px;

  @media screen and(max-width: 1000px) {
    font-size: 13px;
  }

  .print-copy-button {
    width: 250px;
    padding: 15px;
    background: #0066ae;
    color: #fff;
    text-align: center;
    border: none;
    font-size: 1em;
    text-transform: capitalize;
    flex-basis: 5%;
    margin-top: 10px;
    transition: all 0.2s ease-in-out;

    &:active {
      background-color: #005795;
    }
  }

  .scroller {
    flex-basis: 95%;
    overflow: hidden;
  }

  .ticket-list {
    height: 100%;
    overflow: auto;

    &::-webkit-scrollbar {
      width: 0;
    }
  }

  .empty-list {
    padding: .9375rem;
    background-color: #0066ae;
    color: #fff;
  }
}
</style>
